import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogFooter, DialogHeader, DialogTitle } from "@/components/ui/dialog";

type CompletedModalProps = {
  open: boolean;
  onClose: () => void;
  onRestartAll: () => void;
  onGoToTests: () => void;
};

export function CompletedModal({ open, onClose, onRestartAll, onGoToTests }: CompletedModalProps) {
  return (
    <Dialog open={open} onOpenChange={onClose}>
      <DialogContent style={{ boxShadow: "none" }}>
        <DialogHeader>
          <DialogTitle className="text-center text-xl font-black text-slate-700">완료된 학습이에요</DialogTitle>
        </DialogHeader>

        <DialogFooter className="border-t-0 bg-transparent flex flex-col! gap-3">
          <Button className="w-full py-5 text-base font-bold" onClick={onGoToTests}>
            테스트하러 가기
          </Button>

          <Button
            className="w-full py-5 text-base font-bold text-muted-foreground hover:text-muted-foreground"
            variant="ghost"
            onClick={onRestartAll}
          >
            다시 시작하기
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
